import React, {Component} from "react";
import Constants from "../../../constants/constants";

import "./join-live-session.css";

class JoinLiveSession extends Component {
    constructor(props) {    
        super(props);

        this.state = {
            code: ""
        };
    }

    updateCode(event) {
        var newCode = event.target.value;

        this.setState({
            code: newCode
        })
    }

    launchGame(){
        if(this.state.code.length === 4){
            let currURL = new URL(window.location.href)
            const purl = encodeURI(currURL.origin)
            window.location = `${Constants.PLAY_CONTENT_URL}/play_game?room_code=${this.state.code.toUpperCase()}&purl=${purl}`;
        }
    }

    render() {
        return (
        <div>
            <div id='join-multiplayer-top-bar'>
                <img alt='RESTORE logo' id='join-mulitplayer-logo' src={require(`../../../images/RESTORE-Logo.png`)}></img>
            </div>
            <div className='join-multiplayer-container'>
                <div className='join-multiplayer-title'>Welcome to RESTORE-Together</div>
                <div className='join-multiplayer-subtitle'> Insert your 4-letter room code to join the game</div>
                <div className='join-multiplayer-form'>
                <input className='join-multiplayer-input' onChange={(text)=>{ this.updateCode(text)}} placeholder="Insert Room Code"/>
                <button disabled={this.state.code.length!==4} className='join-multiplayer-game-button' onClick={()=>{this.launchGame()}}>Join</button>
                </div>
            </div>
            <div id='join-multiplayer-instructions'>
                <div id='join-multiplayer-instructions-tile'>Instructions:</div>
                <div id='join-multiplayer-instructions-text'>
                
                <p>Please note, Google Chrome is the preferred browser for RESTORE-Skills.</p>
                
                To ready yourself for play:
                <ol>
                <li>Have a red, green, or blue rounded object available (i.e., ball, balloon, apple, playdoh, etc.)</li>
                <li>Position yourself 2-3 feet away from the camera.</li>
                <li>Enter room code</li>
                <li>Allow Camera access</li>
                
                <li>Calibrate your object by choosing the color of your object: Blue, Red, or Green
                Bring your controller to the center of the square, making sure the camera can clearly see the color & shape of the object.</li>
                </ol>
                </div>
            </div>
        </div>
        )
    }
}


export default JoinLiveSession;




// WEBPACK FOOTER //
// ./src/components/containers/join-live-session/join-live-session.js